var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.123,
    height: 19.011,
    viewBox: "0 0 21.123 19.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_200",
    "data-name": "Grupo 200",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_112",
    "data-name": "Caminho 112",
    d: "M22.067,11.449H18.9V4.056A1.056,1.056,0,0,0,17.842,3H3.056A1.056,1.056,0,0,0,2,4.056V18.842a3.172,3.172,0,0,0,3.168,3.168H19.955a3.172,3.172,0,0,0,3.168-3.168V12.505A1.056,1.056,0,0,0,22.067,11.449ZM5.168,19.9a1.056,1.056,0,0,1-1.056-1.056V5.112H16.786v13.73a3.173,3.173,0,0,0,.181,1.056Zm15.842-1.056a1.056,1.056,0,0,1-2.112,0V13.562h2.112Z",
    transform: "translate(0 0)",
    fill: "#2e2e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_113",
    "data-name": "Caminho 113",
    d: "M6,7h8.449V9.112H6Zm0,4.225h8.449v2.112H6Zm5.281,4.225h3.168v2.112H11.281Z",
    transform: "translate(0.225 0.225)",
    fill: "#2e2e36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.057fc1877338565442a81150fcfeccc2.svg";
export { ForwardRef as ReactComponent };